import { useCallback, useEffect } from 'react';
import { resolvePath, To, useNavigate, useResolvedPath } from 'react-router-dom';
import { useMountContext } from 'modules/App/context';
import APP from 'stores/APP';
import URL from 'utils/URL';

interface ProfileNavigateProps {
    to: To;
    replace?: boolean;
}

const ProfileNavigate: React.FC<ProfileNavigateProps> = ({ to, replace }) => {
    const navigate = useProfileNavigate();

    useEffect(() => {
        navigate(to, replace);
    }, [navigate, replace, to]);

    return null;
};

export default ProfileNavigate;

// 使用内嵌模式的路由
const embeddedPath = ['/profile', '/account'];

export function useProfileNavigate() {
    const { isEmbedded } = useMountContext();
    const navigate = useNavigate();
    const basePathname = useResolvedPath('').pathname;
    const profileNavigate = useCallback(
        (to: To, replace?: boolean) => {
            if (!APP.isTiger) {
                const path = resolvePath(to, basePathname);
                const url = URL.merge(window.location.href, {
                    pathname: path.pathname,
                    query: {
                        ...URL.current(path.search).query
                    }
                });
                // 是否属于同一种模式下，即内嵌模式或者非内嵌模式
                const isOneApp = isEmbedded
                    ? embeddedPath.some(item => path.pathname.startsWith(item))
                    : !embeddedPath.some(item => path.pathname.startsWith(item));

                if (isOneApp) {
                    navigate(to, { replace: replace });
                } else if (replace) {
                    window.location.replace(url);
                } else {
                    window.location.href = url;
                }
            } else {
                // app内一定不是内嵌模式，则使用navigate跳转
                navigate(to, { replace: replace });
            }
        },
        [isEmbedded, basePathname, navigate]
    );

    return profileNavigate;
}
